import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchImarcDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/imarc/filter-api`,postData);
        var resData = Object.assign({ type: 'SUCCESS_IMARC_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchImarcSecondaryDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/imarc/country-filter-api`,postData);
        var resData = Object.assign({ type: 'SUCCESS_IMARC_COUNTRY_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchImarcDetailAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/imarc/kpi-page-data`,postData);
        var resData = Object.assign({ type: 'SUCCESS_IMARC_DETAIL_ACTION' }, data);
        dispatch(resData);
    };
};

export {
    FetchImarcDropdownAction,
    FetchImarcSecondaryDropdownAction,
    FetchImarcDetailAction
}